import { render, staticRenderFns } from "./SendSMSMobileCopy.vue?vue&type=template&id=5a73bdcd&"
import script from "./SendSMSMobileCopy.vue?vue&type=script&lang=js&"
export * from "./SendSMSMobileCopy.vue?vue&type=script&lang=js&"
import style0 from "./SendSMSMobileCopy.vue?vue&type=style&index=0&id=5a73bdcd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports